import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#FAFAF8] border-t border-slate-200 mt-20">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src={`${process.env.REACT_APP_BACKEND_URL}/api/files/brand/logo.png`}
              alt="TavoEmocijos" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-slate-600 text-sm leading-relaxed">
              Emocinės sveikatos specialistė, koučerė ir mokymų vedėja. 
              Padėsiu jums geriau pažinti ir valdyti savo emocijas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-['Poppins'] font-semibold mb-4 text-slate-900">Greitos nuorodos</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/apie" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Apie mane</Link></li>
              <li><Link to="/paslaugos" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Paslaugos</Link></li>
              <li><Link to="/mokymai" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Mokymai</Link></li>
              <li><Link to="/parduotuve" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Parduotuvė</Link></li>
              <li><Link to="/kontaktai" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Kontaktai</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-['Poppins'] font-semibold mb-4 text-slate-900">Informacija</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privatumas" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Privatumo politika</Link></li>
              <li><Link to="/salygos" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Pirkimo taisyklės</Link></li>
              <li><Link to="/pristatymas" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Pristatymo sąlygos</Link></li>
              <li><Link to="/grazinimas" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Grąžinimo politika</Link></li>
              <li><Link to="/slapukai" className="text-slate-600 hover:text-[#4CAF50] transition-colors">Slapukų politika</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-['Poppins'] font-semibold mb-4 text-slate-900">Kontaktai</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 text-[#4CAF50] mt-0.5 flex-shrink-0" />
                <a href="mailto:info@tavoemocijos.lt" className="text-slate-600 hover:text-[#4CAF50] transition-colors">
                  info@tavoemocijos.lt
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 text-[#4CAF50] mt-0.5 flex-shrink-0" />
                <a href="tel:+37067838321" className="text-slate-600 hover:text-[#4CAF50] transition-colors">
                  +370 678 38321
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-[#4CAF50] mt-0.5 flex-shrink-0" />
                <span className="text-slate-600">Vilnius, Lietuva</span>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex items-center space-x-4 mt-4">
              <a href="#" className="w-10 h-10 bg-[#E8F5E9] rounded-full flex items-center justify-center text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#FFF3E0] rounded-full flex items-center justify-center text-[#FF9F43] hover:bg-[#FF9F43] hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#E3F2FD] rounded-full flex items-center justify-center text-[#5B9BD5] hover:bg-[#5B9BD5] hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Seller Info */}
        <div className="border-t border-slate-200 mt-8 pt-8">
          <div className="text-center text-sm text-slate-600 space-y-2">
            <p className="font-medium text-slate-700">Pardavėjo informacija</p>
            <p>Dmitrij Borodin | Ind. veiklos pažymos nr. 706574</p>
            <p>El. paštas: info@tavoemocijos.lt | Tel.: +370 678 38321</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-200 mt-6 pt-6 text-center text-sm text-slate-600">
          <p>© {new Date().getFullYear()} TavoEmocijos. Visos teisės saugomos.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;